import Head from 'next/head'
import { Page, Content, Grid } from '@sh24/ui-components'
import SEO from '../components/SEO/seo'
import { CardModule } from '../components/Modules'
import documentToReactComponents from '../utils/document-to-react-components'
import { useAppContext } from '../contexts/app-context'

const PersonTemplate = ({ person }) => {
  const { appContext } = useAppContext()
  const { translations } = appContext

  const heroContent = (
    <>
      <h1>{person.name}</h1>
      <h3>{person.jobTitle}</h3>
      {documentToReactComponents(person.bio)}
    </>
  )

  return (
    <>
      {person.seo && <SEO seo={person.seo} url={person.url} Head={Head} />}
      <Page.Section
        backgroundColour="/primary200"
        decoration="/curve/quarter/left"
      >
        <Page.Content>
          <Content
            width="standard"
            textAlign="left"
            content={heroContent}
          />
        </Page.Content>
      </Page.Section>

      {person.publications && (
        <Page.Section
          backgroundColour="/white"
          decoration="/curve/quarter/leftInverse"
        >
          <Page.Content>
            <Content
              width="standard"
              textAlign="left"
              content={documentToReactComponents(person.publications)}
            />
          </Page.Content>
        </Page.Section>
      )}

      {person.colleagues?.length > 0 && (
        <Page.Section
          backgroundColour="/tertiary200"
        >
          <Page.Content>
            <Content
              width="standard"
              content={(<h2>{translations['person.restOfTeamTitle']}</h2>)}
            />

            <Grid
              width="full-width"
              mobileColumns={1}
              tabletColumns={2}
              desktopColumns={2}
            >
              {person.colleagues.map((colleague) => (
                <CardModule
                  key={colleague.id}
                  cardType="spotlight"
                  id={colleague.id}
                  image={colleague.image}
                  title={colleague.name}
                  content={colleague.jobTitle}
                  link={colleague.url}
                  callToActionText={colleague.name}
                />
              ))}
            </Grid>
          </Page.Content>
        </Page.Section>
      )}
    </>
  )
}

export default PersonTemplate
